const getWorkcellColor = (workcellId, palette, allWorkcellIds = []) => {
  if (allWorkcellIds.length > 0) {
    const sortedIds = [...new Set(allWorkcellIds.map(Number))].sort((a, b) => a - b);
    const index = sortedIds.indexOf(Number(workcellId));
    return palette[index % palette.length];
  }
  return palette[0];
};

export default getWorkcellColor;
